import React from 'react';
import { ShieldIcon } from './icons/CustomIcons';
export function Hero() {
  return <div className="w-full bg-gradient-to-b from-[#0c2340] to-[#1a3a6c] text-white py-16 px-4 md:px-8 lg:px-16" data-id="element-152">
      <div className="max-w-7xl mx-auto" data-id="element-153">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-154">
          <div className="flex-1" data-id="element-155">
            <h1 className="text-4xl md:text-5xl font-bold text-[#e9d28f] mb-4" data-id="element-156">
              Unshakable Conviction
            </h1>
            <h2 className="text-xl md:text-2xl mb-6" data-id="element-157">
              The Untold Story of Courage, Faith, and the Battle for America's
              Future
            </h2>
            
            <p className="text-xl mb-8 italic" data-id="element-158">
              "They Tried to Silence Him. But Truth Cannot Be Broken."
            </p>
            <button onClick={() => {
            document.getElementById('pricing-section').scrollIntoView({
              behavior: 'smooth'
            });
          }} className="bg-red-700 hover:bg-red-800 text-white font-bold py-3 px-8 rounded-md transition duration-300 flex items-center cursor-pointer" data-id="element-159">
              <ShieldIcon className="mr-2 h-5 w-5" data-id="element-160" />
              Secure Your Copy
            </button>
          </div>
          <div className="flex-1" data-id="element-161">
            <div className="relative" data-id="element-162">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8trgeA7VZR5XjJR2ciDSJW/Generated_Image_September_26%2C_2025_-_6_11PM.png" alt="Unshakable Conviction Book Cover" className="w-full max-w-md mx-auto rounded-md shadow-2xl transform hover:scale-105 transition duration-500" data-id="element-163" />
              <div className="absolute -bottom-4 -right-4 bg-[#e9d28f] text-[#0c2340] font-bold py-2 px-4 rounded-full shadow-lg" data-id="element-164">
                New Release
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}